import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { CalendarModule } from 'primeng/calendar';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DialogModule } from 'primeng/dialog';

import { OnePageComponent } from './one-page.component';

@NgModule({
  declarations: [
    OnePageComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    CalendarModule,
    ButtonModule,
    ProgressSpinnerModule,
    DialogModule
  ],
  exports: [
    OnePageComponent
  ]
})
export class OnePageModule {}